export default __webpack_public_path__ + "static/media/undraw-security-o-890-1.c59e0d04.png";